<template>
  <button class="top-3" title="Close chat window" @click="chatBotStore.toggleChat()">
    <img src="../svg/close.svg" alt="Close chat" />
  </button>
</template>
<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();
</script>
